import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { FireblockService } from '../fireblockvault/fireblockvault.service';
@Component({
    selector: 'app-fireblocktransactions',
    templateUrl: './fireblocktransactions.component.html',
    styleUrls: ['./fireblocktransactions.component.css']
})
export class FireblockTransactionsComponent implements OnInit {
    displayedColumns = [
        'lastUpdated',
        'txId',
        'status',
        'product',
        'internal_txntype',
        'assetId',
        'assetType',
        'amount',
        'networkFee',
        'feeCurrency',
        'netAmount',
        'txHash',
        'externalTxId',
        'event_type',
        'subStatus',
        'source_id',
        'destination_id',
        'source_type',
        'source_name',
        'source_subType',
        'source_address',
        'destination_count',
        'destination_type',
        'destination_name',
        'destination_subType',
        'destination_address',
        'destinations',
        'note',
        'is_processed',
        'is_error',
        'createdAt'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<cjunctionData>;
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private fireblock: FireblockService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.fireblock.getFireblockTransactions(this.filter).subscribe((success) => {
                let cjunctionRes = success.map(cjunctionTrans => {
                    cjunctionTrans.createdAt = moment(cjunctionTrans.createdAt).format('MM/DD/YY h:mm:ss A');
                    cjunctionTrans.lastUpdated = moment(cjunctionTrans.lastUpdated).format('MM/DD/YY h:mm:ss A');
                    return cjunctionTrans;
                })
                this.dataSource = new MatTableDataSource(cjunctionRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const fireblockTransactions = await this.dataSource.filteredData.map(x => ({
                txId: x.txId,
                tenantId: x.tenantId,
                subStatus: x.subStatus,
                status: x.status,
                product: x.product,
                assetId: x.assetId,
                amount: x.amount,
                fee: x.fee,
                feeCurrency: x.feeCurrency,
                netAmount: x.netAmount,
                networkFee: x.networkFee,
                txHash: x.txHash,
                note: x.note,
                source_id: x.source_id,
                source_type: x.source_type,
                source_name: x.source_name,
                source_subType: x.source_subType,
                destination_count: x.destination_count,
                source_address: x.source_address,
                destination_id: x.destination_id,
                destination_type: x.destination_type,
                destination_name: x.destination_name,
                destination_subType: x.destination_subType,
                destination_address: x.destination_address,
                destinations: x.destinations,
                is_processed: x.is_processed,
                is_error: x.is_error,
                event_type: x.event_type,
                internal_txntype: x.internal_txntype,
                createdAt: x.createdAt,
                lastUpdated: x.lastUpdated,
            }));
            TableUtil.exportArrayToExcel(fireblockTransactions, "fireblock-trans");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface cjunctionData {
    txId: string,
    tenantId: string,
    currency: number,
    amount: number,
    assetId: number,
    subStatus: number,
    product: number,
    status: number,
    fee: number,
    feeCurrency: number,
    netAmount: number,
    networkFee: string,
    txHash: string,
    note: string,
    source_id: string,
    source_type: string,
    source_name: string,
    source_subType: string,
    destination_count: string,
    source_address: string,
    destination_id: string,
    destination_type: string,
    destination_name: string,
    destination_subType: string,
    destination_address: string,
    destinations: string,
    is_processed: string,
    is_error: string,
    event_type: string,
    internal_txntype: string,
    createdAt: string,
    lastUpdated: string,
} 


// WEBPACK FOOTER //
// ./src/app/fireblocktransactions/fireblocktransactions.component.ts